import React from "react";
import CalculPlusValueImmobiliere from "../components/CalculPlusValueImmobiliere";
import { useSEO } from "../hooks/useSEO";

export default function CalculPlusValueImmobilierePage() {
  useSEO({
    title: "Calculateur Plus-Value Immobilière Gratuit",
    description: "Calculez gratuitement la plus-value de votre bien immobilier et l'impôt à payer. Simulation avec abattements pour durée de détention."
  });

  return <CalculPlusValueImmobiliere />;
}
